module.exports = __webpack_public_path__ + "static/img/limit_03.f30dfc37.svg";